"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(blob, count) {
  return blob.substr(0, count) + '…';
};

exports["default"] = _default;